export const levels = ['debug', 'trace', 'info', 'warn', 'error'];
/*
 * winston logger default normally to npm logging levels
 * https://github.com/winstonjs/winston?tab=readme-ov-file#logging-levels
 * {
 *   error: 0,
 *   warn: 1,
 *   info: 2,
 *   http: 3,
 *   verbose: 4,
 *   debug: 5,
 *   silly: 6
 * }
 */
export const customLevels = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
    trace: 4,
};
